import { ReactNode, useMemo } from 'react';
import { DataTable, TableColumnType } from '@ui';
import { useInfiniteScroll } from '@heroui/use-infinite-scroll';
import { Spinner } from '@ds';
import { ResourceRowData } from '@features/components/CaseOverview/components/AssignedResources/types';
import { getRenderResourceTableCell } from './getResourceCell';
import { CustomerRoleT } from '@/api/apis/customer';

type ResourceTableProps = {
  columns: TableColumnType[];
  hasNextPage: boolean;
  isFirstLoading: boolean;
  loadNextPage: () => void;
  onUserAssign: (arg0: ResourceRowData) => void;
  list: ResourceRowData[];
  thClassName?: string;
  selectedRole?: CustomerRoleT;
  renderCell?: (item: ResourceRowData, columnKey: string) => ReactNode;
};

export const ResourceTable = ({
  onUserAssign,
  columns,
  list,
  thClassName,
  hasNextPage,
  isFirstLoading,
  loadNextPage,
  selectedRole,
  renderCell,
}: ResourceTableProps) => {
  const [loaderRef, scrollerRef] = useInfiniteScroll({
    hasMore: hasNextPage,
    onLoadMore: loadNextPage,
  });

  const defaultRenderCell = useMemo(
    () => getRenderResourceTableCell(onUserAssign, selectedRole),
    [onUserAssign, selectedRole],
  );

  return (
    <DataTable
      type="infinite"
      baseRef={scrollerRef}
      label="Contacts"
      baseClassName="min-h-[400px] max-h-[400px]"
      thClassName={thClassName}
      hidePadding
      columns={columns}
      renderCell={renderCell || defaultRenderCell}
      bottomContent={
        hasNextPage ? (
          <div className="flex w-full justify-center">
            <Spinner size="md" ref={loaderRef} />
          </div>
        ) : null
      }
      data={list}
      isLoading={false}
      isFetching={isFirstLoading}
      isHeaderSticky
    />
  );
};
